import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * The protocol of one order: every state it and each of its picking rounds moved into, newest
 * first.
 *
 * `"order"` leads the key so the order mutations already invalidating that segment refresh the
 * protocol too — cancelling an order writes a transition, and a stale panel beside a fresh header
 * is the one thing a protocol may not do.
 */
export function useOrderStateTransitions(orderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["order", guardString(orderId), "state-transitions"],
		queryFn: async () => {
			const response = await client.stock.orders[":orderId"]["state-transitions"].$get({
				param: { orderId: guardString(orderId) },
			});
			// Suppressed for the same reason as `useOrder`: the page renders the refusal itself.
			const data = await responseHandler(response, false);
			return data.stateTransitions;
		},
		enabled: !!orderId,
	});

	/** Return */
	return { ...query, stateTransitions: query.data };
}
